module.exports = __webpack_public_path__ + "media/images/flags/gb-sct-5fd810e3705601b70a5add516a4127a0.svg";